import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { AddBtn } from "@commonComponents/AddBtn";
import { FormTitle } from "@commonComponents/FormTitle";


const ActiveTransportDetail = ({translate,renderForm,addItem,tableName="activeTransportMeansList",updateItem:onChange,saveItem:onBlur,onSelect}) => { 
    const dataSource = useSelector((state) => state.transportReducer[tableName]);
    useEffect(()=>{
        if(dataSource.length==0)
              addItem(tableName)
      },[])
    return (
    <div className="col grow formContainer">
    <FormTitle className="formTitle" textAlign="start" title="ACTIVE_TRANS_MEANS" />
    {dataSource.length>0 ? renderForm({onChange,onBlur,dataSource:dataSource[0],onSelect,tableName,translate}) : <AddBtn  onClick={()=>addItem(tableName)} text={translate("ADD")} />}
    </div>
    )
  
}

export default React.memo(ActiveTransportDetail)
